<template>
  <div class="latest_news pt-4">
    <h3><div class="tabs-prd-title"> <span >Tin liên quan</span></div>    </h3> 
    
    <div class="content-post">
      <ul>
        <li v-for="(news, index) of latestNews" :key="index">
          <article class="blog-item-list clearfix">
            <router-link
              exact
              :to="{
                  name: 'news',
                  params: { slug: news.seoName }
                
                }"
                class="panel-box-media"
            >
              <img v-bind:src="getImageNews(news)" v-bind:title="news.title" />
            </router-link>

            <div class="blogs-rights">
              <h3 class="blog-item-name">
                <router-link
                  exact
                  :to="{
                    name: 'news',
                    params: { slug: news.seoName }
                  }"
                >{{news.title}}</router-link>
              </h3>
            </div>
          </article>
        </li>
      </ul>
    </div>
  </div>
  
</template>
<script>
import { mapGetters } from "vuex";
import util from "@/common/util";

export default {
  name: "RwvLatestNews",
  components: {},
  props: {
  },
  computed: {
    ...mapGetters(["latestNews"])
  },
  methods: {
    getImageNews(data) {
      return util.getImageNews(data.imageURL);
    }
  }
};
</script>